import { render, staticRenderFns } from "./deposit-deduction-record.vue?vue&type=template&id=fda5a9d2&scoped=true&"
import script from "./deposit-deduction-record.vue?vue&type=script&lang=js&"
export * from "./deposit-deduction-record.vue?vue&type=script&lang=js&"
import style0 from "./deposit-deduction-record.vue?vue&type=style&index=0&id=fda5a9d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fda5a9d2",
  null
  
)

export default component.exports